export const logout = (redirect = false) => {
  ADV.Controller.logout(redirect, false);
};
